import { useEffect, useState } from "react";
import { Square } from "lucide-react";
import { speech } from "@/lib/speech";

export const useSpeech = () => {
  const [st, setSt] = useState({ speakingId: null, loading: false });
  useEffect(() => speech.subscribe(setSt), []);
  return st;
};

export const SpeakingBar = ({ s, full }) => {
  const st = useSpeech();
  if (!st.speakingId) return null;
  return (
    <div role="status" data-testid="chat-speaking-bar"
      className={`mt-2 flex items-center justify-between gap-3 bg-hv-navy px-3 py-2 text-white ${full ? "mx-auto max-w-3xl" : ""}`}>
      <span className="flex items-center gap-2 text-[12px]">
        <span className="flex h-3 items-end gap-[2px]" aria-hidden="true">
          {[0, 1, 2, 3].map((i) => <span key={i} className="ceres-eq w-[3px] bg-hv-orange" style={{ animationDelay: `${i * 120}ms` }} />)}
        </span>
        {st.loading ? s.preparingVoice : s.speaking}
      </span>
      <button type="button" onClick={() => speech.stop()} data-testid="chat-speaking-stop-button"
        className="inline-flex items-center gap-1 border border-white px-2 py-0.5 font-heading text-[11px] font-semibold uppercase tracking-wider transition-colors hover:bg-white hover:text-hv-navy">
        <Square size={10} aria-hidden="true" />{s.stopVoice}
      </button>
    </div>
  );
};
